export interface SocialLink {
  iconName: 'Github' | 'Linkedin' | 'Code2' | 'BarChart3';
  href: string;
  label: string;
}

export interface Experience {
  title: string;
  company: string;
  period: string;
  current: boolean;
}

export interface SkillCategory {
  label: string;
  skills: string[];
}

export const socialLinks: SocialLink[] = [
  { iconName: 'Github', href: 'https://github.com/BEllis0', label: 'GitHub' },
  { iconName: 'Linkedin', href: 'https://www.linkedin.com/in/brandon-t-ellis', label: 'LinkedIn' },
];

export const experience: Experience[] = [
  {
    title: 'Senior Software Engineer',
    company: 'Symetra Financial',
    period: 'July 2025 - Present',
    current: true,
  },
  {
    title: 'Senior Software Engineer - Technical Lead',
    company: 'Panasonic - Smart Mobility Office',
    period: 'April 2024 - March 2026',
    current: false,
  },
  {
    title: 'Full Stack Software Engineer',
    company: 'Panasonic - Smart Mobility Office',
    period: 'April 2022 - April 2024',
    current: false,
  },
  {
    title: 'Front End Developer / Tag Implementation Engineer',
    company: 'Lumen Technologies',
    period: 'July 2020 - March 2022',
    current: false,
  },
  {
    title: 'Founder, Consultant',
    company: 'BT Digital',
    period: 'Sept 2017 - Present',
    current: true,
  },
];

export const skillCategories: SkillCategory[] = [
  { label: 'Front End', skills: ['TypeScript', 'React', 'Angular', 'React Native', 'Redux', 'HTML', 'CSS'] },
  { label: 'Back End', skills: ['Node.js', 'Python', 'Lambda', 'Express', 'GraphQL', 'API Gateway'] },
  { label: 'Cloud / DevOps', skills: ['AWS', 'CDK', 'CloudFormation', 'Docker', 'CI/CD', 'IaC', 'Heroku', 'Amplify'] },
  { label: 'Databases', skills: ['PostgreSQL', 'DynamoDB', 'MongoDB', 'MySQL', 'OpenSearch'] },
  { label: 'Tools / Techniques', skills: ['Git', 'Webpack', 'Vite', 'OpenAPI', 'MVC Architecture', 'Microservices', 'Event-Driven Architecture', 'RESTful APIs'] },
];
